(function ($) {
    'use strict';

    function resetFileVideoShell($wrap) {
        var label = $wrap.attr('data-play-label');
        $wrap.attr({
            tabindex: '0',
            role: 'button',
        });
        if (label) {
            $wrap.attr('aria-label', label);
        }
    }

    function startFileVideo($wrap) {
        if ($wrap.hasClass('is-playing')) {
            return;
        }
        var video = $wrap.find('.media-slider-file-video__el').get(0);
        if (!video) {
            return;
        }
        $wrap.addClass('is-playing');
        $wrap.removeAttr('role').removeAttr('tabindex').removeAttr('aria-label');
        video.setAttribute('controls', 'controls');
        video.play();
    }

    /**
     * Pauses inline video, iframe embeds (YouTube / Vimeo), and Vidyard in a container.
     * Used by the media slider when leaving a slide; callable for any layout.
     *
     * @param {Element} containerEl
     */
    function pauseEmbeddedMedia(containerEl) {
        if (!containerEl) {
            return;
        }

        $(containerEl).find('.media-slider-file-video').removeClass('is-playing').each(function () {
            resetFileVideoShell($(this));
        });
        $(containerEl).find('.media-slider-file-video__el').each(function () {
            var v = this;
            v.removeAttribute('controls');
            v.pause();
            try {
                v.currentTime = 0;
            } catch (e) {}
        });

        containerEl.querySelectorAll('iframe').forEach(function (iframe) {
            var src = iframe.src || iframe.getAttribute('src') || '';
            try {
                if (src.indexOf('youtube.com') !== -1 || src.indexOf('youtube-nocookie.com') !== -1) {
                    iframe.contentWindow.postMessage(JSON.stringify({
                        event: 'command',
                        func: 'pauseVideo',
                        args: '',
                    }), '*');
                } else if (src.indexOf('player.vimeo.com') !== -1 || src.indexOf('vimeo.com') !== -1) {
                    iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                }
            } catch (e) {}
        });

        containerEl.querySelectorAll('.media-slider-vidyard [data-uuid], img.vidyard-player-embed[data-uuid]').forEach(function (node) {
            var uuid = node.getAttribute('data-uuid');
            if (!uuid) {
                return;
            }
            try {
                if (window.VidyardV4 && window.VidyardV4.api && typeof window.VidyardV4.api.getPlayersByUUID === 'function') {
                    var players = window.VidyardV4.api.getPlayersByUUID(uuid);
                    if (players && players.length && typeof players[0].pause === 'function') {
                        players[0].pause();
                    }
                }
            } catch (e) {}
        });
    }

    window.FlutterbeeVideo = {
        pauseEmbeddedMedia: pauseEmbeddedMedia,
    };

    $(function () {
        $(document).on('click', '.media-slider-file-video:not(.is-playing)', function (e) {
            startFileVideo($(this));
        });

        $(document).on('keydown', '.media-slider-file-video:not(.is-playing)', function (e) {
            var key = e.which || e.keyCode;
            if (key !== 13 && key !== 32) {
                return;
            }
            e.preventDefault();
            startFileVideo($(this));
        });
    });
})(jQuery);
